import type { FiltersInterface } from '@/types/Miscellaneous';

export const advancedProjectFilterKeys = [
  'name',
  'constructionType',
  'state',
  'leadId',
  'memberId',
  'titleId',
  'neighborhood',
  'archived',
  'departmentLedProject',
] as const;

export function replaceAdvancedProjectFilters(current: FiltersInterface, nextAdvanced: FiltersInterface): FiltersInterface {
  const nextFilters = { ...current };
  for (const key of advancedProjectFilterKeys) delete nextFilters[key];
  return { ...nextFilters, ...nextAdvanced };
}

export function retainProjectSort(current: FiltersInterface): FiltersInterface {
  return Object.fromEntries(Object.entries(current).filter(([key]) => key === 'order' || key === 'orderBy')) as FiltersInterface;
}
